import type { SourceUsageDomainType } from "@/components/SourceTable/types";
import { DOMAIN_TO_TYPE } from "./const";
import { getDomainFromUrl } from "../url/getDomainFromUrl";

/**
 * Returns domain type by name. Unknown domains return "other".
 */
export function getDomainType(domain: string): SourceUsageDomainType {
  const normalized = getDomainFromUrl(domain);
  if (!normalized) return "other";

  const types: Array<Exclude<SourceUsageDomainType, "other">> = ["news", "social", "forum"];
  for (const type of types) {
    if (DOMAIN_TO_TYPE[type].includes(normalized)) return type;
  }
  return "other";
}
